import './http';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import './assets/scss/styles.scss';
import 'bootstrap';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { firebaseConfig } from '../firebase.config';
import "vue-toastification/dist/index.css";
import Toast, {POSITION, useToast} from "vue-toastification";
import * as Sentry from "@sentry/vue";
import * as ConfirmDialog from 'vuejs-confirm-dialog';
import VueGoodTablePlugin from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import mitt from 'mitt';
import Dropzone from 'dropzone-vue3';
import 'floating-vue/dist/style.css';
import FloatingVue from 'floating-vue';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import "@vueform/multiselect/themes/default.css";
import i18n from "@/i18n";
import {defineRule} from 'vee-validate';

// import "vue-skeletor/dist/vue-skeletor.css";
import { Skeletor } from "vue-skeletor";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import {getAppDomain} from "@/helper";

const emitter = mitt();
window.emitter = emitter;
const app = createApp(App);

const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);
app.use(Dropzone);

window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

app.component('dropzone', Dropzone);
app.component('QuillEditor', QuillEditor);
app.component('VueSlider', VueSlider);

// Řada service metod odmítá promise nediagnostikovatelnou hodnotou (null/undefined
// nebo prázdné pole) místo skutečné chyby - takové rejections neobsahují nic k debugování.
function isNonDiagnosticRejection(reason) {
    return reason === null || reason === undefined || (Array.isArray(reason) && reason.length === 0);
}

app.config.errorHandler = (err, vm, info) => {
    if (err && err.name === 'ChunkLoadError') {
        console.error('ChunkLoadError detected. Reloading page...');
        window.location.reload();
    } else {
        Sentry.captureException(err)
        console.error('Unexpected error:', err)
    }
}

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        app,
        dsn: "https://0658d861444142e3a8a8c3af93a1b082@o4508284053225472.ingest.de.sentry.io/4508284057878608",
        integrations: [],
        beforeSend(event, hint) {
            // Řada service metod (např. ClientService, ServiceRequirementService...) při
            // chybě API volání dělá reject([]) / reject(null) místo reject(error) a volající
            // často chybu nezachytává pomocí .catch(). To zaplavuje Sentry nesmyslnými
            // "Non-Error promise rejection" eventy bez jakékoliv diagnostické hodnoty
            // (viz CLIENT-APP-FRONTEND-M, CLIENT-APP-FRONTEND-6T).
            if (isNonDiagnosticRejection(hint?.originalException)) {
                return null;
            }

            event.extra = {
                ...event.extra,
                branch: getAppDomain(),
            }

            return event
        },
    });

    // Bezpečnostní síť pro nezachycené promise rejections - zabrání výpisu
    // "Uncaught (in promise)" do konzole u chyb, které jsou svým obsahem
    // nediagnostikovatelné (prázdné pole, null/undefined) a jsou odfiltrované
    // i v beforeSend výše.
    window.addEventListener('unhandledrejection', (event) => {
        if (isNonDiagnosticRejection(event.reason)) {
            event.preventDefault();
        }
    });
}

app.use(FloatingVue);
app.use(ConfirmDialog);
app.component(Skeletor.name, Skeletor);
app.use(VueGoodTablePlugin);
app.use(router);
app.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 1,
    newestOnTop: true
});
app.use(i18n);

// validation rules
defineRule('min', (value, [minLength]) => {
    if (!value) return 'Pole je povinné';
    if (value.length >= Number(minLength)) return true;
    return `Pole musí mít alespoň ${minLength} znaků`;
});

defineRule('max', (value, [maxLength]) => {
    if (!value) return true; // prázdné pole je ok, pokud není required
    if (value.length <= Number(maxLength)) return true;
    return `Pole nesmí mít více než ${maxLength} znaků`;
});
defineRule('phoneNumber', (value) => {
    if (!value) {
        return 'Telefonní číslo je povinné';
    }

    const phoneRegex = /^\+(\d{11,13})$/;

    return phoneRegex.test(value) ? true : 'Neplatný formát telefonního čísla';
});
defineRule('required', value => {
    if (!value || !value.length) {
        return 'Toto políčko je povinné';
    }
    return true;
});
defineRule('email', value => {
    if (!value) {
        return true;
    }

    if(!String(value)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )) {
        return 'Vyplňte prosím platný e-mail';
    }

    return true;

});
defineRule('sameAs', (value, [target], ctx) => {
    if (value === ctx.form[target]) {
        return true
    }

    return 'Hesla se neshodují';
});

await router.isReady();
app.mount('#app');
